export const BUILD_VERSION = '1774948362189';
